export default "__VITE_ASSET__JVD9bs$x__"